import styled, { createGlobalStyle } from 'styled-components';

export const OzoneFonts = createGlobalStyle`
  $font-prefix: '' !default;

  :root {
    --ozn-font-sans: 'IBM Plex Sans', 'Helvetica Neue', Arial, sans-serif;
    --ozn-font-mono: 'IBM Plex Mono', 'Menlo', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', Courier, monospace;
  }
`;

export const Sans = styled.span`
  color: var(--gray-100);
  font-family: var(--ozn-font-sans);
`;

export const Mono = styled.span`
  color: var(--gray-100);
  font-family: var(--ozn-font-mono);
`;

export const TextWrapper = styled.div`
  padding: ${({ theme }) => (theme as any).spacing?.normal};
  padding-right: 15% !important;
`;
